<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'lockExceptionAuditList',
})
</script>
<template>
    <a-card :bordered="false">
        <!-- 搜索区 -->
        <div class="search-wrap">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="6" :sm="24">
                        <a-form-item label="主体名称">
                            <a-input v-model:value="queryParam.nameOrCode" placeholder="请输入主体名称、税号" allow-clear
                                @keyup.enter="handleSearch" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="平台名称">
                            <a-select v-model:value="queryParam.platform_id" mode="multiple" allow-clear
                                placeholder="请选择平台">
                                <a-select-option v-for="(item, index) in state.platformList" :key="index"
                                    :value="item.id">{{ item.platform_abbreviation }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="状态">
                            <a-select v-model:value="queryParam.status" mode="multiple" allow-clear placeholder="请选择">
                                <a-select-option :value="0">待审核</a-select-option>
                                <a-select-option :value="1">已锁定</a-select-option>
                                <a-select-option :value="2">取消锁定</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="锁定理由">
                            <a-input v-model:value="queryParam.reason" placeholder="请输入" allow-clear
                                @keyup.enter="handleSearch" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="录入系统时间">
                            <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                                :format="format" @change="rangTimeChange" style="width: 100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <span class="search-btns">
                            <a-button type="primary" @click="handleSearch">查询</a-button>
                            <a-button style="margin-left: 8px" @click="refreshTable">重置</a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>

        <!-- 表格 -->
        <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
            @change="onChange" size="middle" class="lock-table"
            :rowClassName="(record) => (record.status === 0 ? 'row-pending' : '')">
            <template #bodyCell="{ column, record, text }">
                <!-- 公司名称 -->
                <template v-if="column.dataIndex === 'name'">
                    <div class="company-block">
                        <div class="company-name">{{ record.full_name }}</div>
                        <div class="company-meta">
                            <span class="meta-item">👤 代理商：{{ record.seller || '--' }}</span>
                        </div>
                        <div class="company-meta">
                            <span class="meta-item">📍 入驻地址：{{ record.full_address_number || '--' }}</span>
                        </div>
                        <a class="detail-link" @click="goCustomerClick(record.full_name)">查看详情</a>
                    </div>
                </template>

                <!-- 锁定信息 -->
                <template v-else-if="column.dataIndex === 'lockInfo'">
                    <div class="info-block">
                        <div class="status-line">
                            <a-tag v-if="record.status == 0" color="processing">待审核</a-tag>
                            <a-tag v-if="record.status == 1" color="success">已锁定</a-tag>
                            <a-tag v-if="record.status == 2" color="error">取消锁定</a-tag>
                        </div>
                        <div class="info-row">
                            <span class="info-label">锁定时间</span>
                            <span class="info-value time-text">{{ record.start_time }} ~ {{ record.end_time }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">理由</span>
                            <span class="info-value">{{ record.reason || '--' }}</span>
                        </div>
                        <div v-if="record.url?.length" class="info-row attach-row">
                            <span class="info-label">附件</span>
                            <div class="attach-list">
                                <template v-for="(item, index) in record.url" :key="index">
                                    <a-image v-if="isImage(item)" :width="56" :height="56" :src="imageDomain + item"
                                        class="attach-img" />
                                </template>
                            </div>
                        </div>
                        <div class="info-row">
                            <span class="info-label">备注</span>
                            <span class="info-value">{{ record.remark || '--' }}</span>
                        </div>
                    </div>
                </template>

                <!-- 取消锁定 -->
                <template v-else-if="column.dataIndex === 'unlockInfo'">
                    <div class="info-block">
                        <div class="info-row">
                            <span class="info-label">审核备注</span>
                            <span class="info-value">{{ record.audit_remark || '--' }}</span>
                        </div>
                        <div v-if="record.audit_url?.length" class="info-row attach-row">
                            <span class="info-label">附件</span>
                            <div class="attach-list">
                                <template v-for="(item, index) in record.audit_url" :key="index">
                                    <a-image v-if="isImage(item)" :width="56" :height="56" :src="imageDomain + item"
                                        class="attach-img" />
                                </template>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- 操作 -->
                <template v-else-if="column.dataIndex === 'action'">
                    <div v-if="record.status == 0" class="audit-ops">
                        <a-input v-model:value="record.desc" placeholder="选填：通过或拒绝的理由" allow-clear
                            style="margin-bottom:8px" />
                        <div class="audit-btns">
                            <a-popconfirm title="确定不通过?" @confirm="verificatioChange(record, 2)">
                                <a-button danger style="flex:1">不通过</a-button>
                            </a-popconfirm>
                            <a-popconfirm title="确定通过?" @confirm="verificatioChange(record, 1)">
                                <a-button type="primary" style="flex:1">通过</a-button>
                            </a-popconfirm>
                        </div>
                    </div>
                    <div v-else-if="record.status == 1">
                        <a-button type="primary" @click="cancelLock(record)">取消锁定</a-button>
                    </div>
                </template>
            </template>
        </a-table>

        <!-- 取消锁定弹窗 -->
        <CancelLockException v-if="state.cancelVisible" :detailData="state.detailData" @cancel="handleCancel"
            @ok="handleOk" />
    </a-card>
</template>

<script lang="ts" setup name="lockExceptionAuditList">
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import baseService from '@/utils/http/axios'
import CancelLockException from './components/CancelLockException.vue'

const router = useRouter()
const $store = useStore()
const imageDomain = computed(() => $store.state.user.image_domain)

const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const format = 'YYYY-MM-DD HH:mm:ss'

const state = reactive({
    loading: false,
    platformList: [] as any[],
    detailData: {} as any,
    cancelVisible: false
})

const columns = [
    { title: '公司名称', dataIndex: 'name', width: 280 },
    { title: '锁定信息', dataIndex: 'lockInfo', width: 380 },
    { title: '取消锁定', dataIndex: 'unlockInfo', width: 300 },
    { title: '申请时间', dataIndex: 'created_at', width: 170 },
    { title: '操作', dataIndex: 'action', width: 220 }
]

const createDefaultQuery = () => ({
    nameOrCode: '',
    platform_id: [] as any[],
    status: [0] as number[],
    reason: '',
    between_time: null as string | null
})

const queryParam = reactive<any>(createDefaultQuery())
const dataSource = ref<any[]>([])

const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '40', '50', '60', '200'],
    current: 1,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})

onMounted(() => {
    loadData()
    getPlatformList()
})

// ---------- 工具 ----------
const isImage = (url: string) => /\.(png|jpe?g)$/i.test(url || '')

// ---------- 加载 ----------
const loadData = () => {
    if (state.loading) return
    state.loading = true
    baseService({
        url: '/admin/v1/lockExceptionList',
        method: 'post',
        data: { page: pagination.current, limit: pagination.pageSize, ...queryParam }
    })
        .then((res) => {
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item: any) => ({ ...item, desc: null }))
        })
        .catch((res) => message.error(res.msg || '列表查询失败,请联系管理员'))
        .finally(() => (state.loading = false))
}

const handleSearch = () => {
    pagination.current = 1
    loadData()
}

const refreshTable = () => {
    Object.assign(queryParam, createDefaultQuery())
    pagination.current = 1
    loadData()
}

// ---------- 时间选择 ----------
const rangTime = computed(() => {
    if (!queryParam.between_time) return []
    return queryParam.between_time.split(',').map((item: string) => dayjs(item, format))
})

const rangTimeChange = (val: any, str: string[]) => {
    queryParam.between_time = val ? str.join(',') : null
}

const goCustomerClick = (name: string) => {
    router.push({ path: '/customer', query: { customer_name: name } })
}

// ---------- 分页 ----------
const onChange = (val: any) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}

// ---------- 审核 ----------
const verificatioChange = (record: any, type: number) => {
    baseService({
        url: '/admin/v1/lockException/check',
        method: 'post',
        data: { reason: record.desc, status: type, id: record.id }
    })
        .then(() => {
            message.success('操作成功')
            loadData()
        })
        .catch((res) => message.error(res.msg || '操作失败,请联系管理员'))
}

// ---------- 取消锁定 ----------
const cancelLock = (record: any) => {
    state.detailData = record
    state.cancelVisible = true
}

const handleOk = () => {
    state.cancelVisible = false
    loadData()
}

const handleCancel = () => {
    state.cancelVisible = false
}

// ---------- 平台列表 ----------
const getPlatformList = () => {
    baseService({
        url: '/admin/v1/platformList',
        method: 'post',
        data: { limit: 'all' }
    })
        .then((res) => {
            state.platformList = res.data.list
        })
        .catch((res) => message.error(res.msg || '平台列表查询失败,请联系管理员'))
}
</script>

<style lang="less" scoped>
// ---------- 搜索区 ----------
.search-wrap {
    margin-bottom: 16px;
    padding: 16px 16px 0;
    background: #fafbfc;
    border-radius: 8px;
}

.search-btns {
    display: inline-block;
    margin-bottom: 24px;
    white-space: nowrap;
}

// ---------- 表格 ----------
.lock-table {
    :deep(.ant-table-thead > tr > th) {
        background: #fafafa;
        font-weight: 600;
        color: #262626;
    }

    :deep(.ant-table-tbody > tr.row-pending > td) {
        background: #fffbf0;
    }

    :deep(.ant-table-tbody > tr > td) {
        vertical-align: top;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}

// ---------- 公司信息 ----------
.company-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.company-name {
    font-size: 13px;
    font-weight: 600;
    color: #262626;
    word-break: break-all;
}

.company-meta {
    font-size: 12px;
    line-height: 1.5;
}

.meta-item {
    color: #8c8c8c;
    word-break: break-all;
}

.detail-link {
    font-size: 12px;
    margin-top: 2px;
}

// ---------- 信息块 ----------
.info-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
}

.status-line {
    margin-bottom: 2px;
}

.info-row {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    line-height: 1.6;
}

.info-label {
    flex-shrink: 0;
    min-width: 56px;
    color: #8c8c8c;
}

.info-value {
    color: #262626;
    word-break: break-all;
}

.time-text {
    color: #595959;
}

.attach-row {
    align-items: flex-start;
}

// ---------- 附件 ----------
.attach-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    flex: 1;
}

.attach-img {
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #f0f0f0;
    transition: transform 0.2s;

    &:hover {
        transform: scale(1.05);
    }
}

// ---------- 审核操作 ----------
.audit-ops {
    display: flex;
    flex-direction: column;
}

.audit-btns {
    display: flex;
    gap: 8px;
}

:deep(.ant-image) {
    margin-right: 0;
    margin-bottom: 0;
}

.customer-options-popover {
    p {
        padding: 0 16px;
        margin: 0;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        text-align: center;
        color: #000;
    }

    p:hover {
        color: var(--ant-primary-color);
        background: var(--ant-primary-color-deprecated-bg);
    }
}
</style>
